export function formatWeekDay(date) {
  // noinspection JSCheckFunctionSignatures
  const weekday = date.toLocaleString('en-US', { weekday: 'long' });

  return weekday;
}

/**
 * Get the date in MM/DD/YYYY format
 * @param date
 * @returns {string}
 */
export function formatDate(date) {
  // noinspection JSCheckFunctionSignatures
  const formattedDate = date.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
  return formattedDate;
}

/**
 * Get the time in HH:MM AM/PM format
 * @param {Date} date
 * @returns {string}
 */
export function formatTime(date) {
  const options = { hour: 'numeric', minute: 'numeric', hour12: true };
  const time = date.toLocaleTimeString('en-US', options);
  return time;
}

export function formatFullDate(date) {
  const weekday = formatWeekDay(date);

  const calendarDate = formatDate(date);

  const time = formatTime(date);

  return `${weekday}, ${calendarDate}, ${time}`;
}
